import React, { Component } from "react";
import { LibertateContext } from "./Context";

export class LibertateContextProvider extends Component {
  state = {
    perStateQuoteTableData: {},
    programs: [],
    masterWithoutFundRateMap: {},
    programStateType: {},
    peoData: {},
    excludedClassCodeMap: {},
    currentCarrierMap: {},
    stateCarrierData: {},
    uwNetRates: {},
    uwFileList: {
      third: {},
    },
    carrierBasedData: {},
    hideButtons: false,
    userStatusData: {},
    userData: {},
    formStage: "zero",
    currProspect: {},
    classCodeObjectContext: {},
    displayLoader: true,
    acordUwQues: [],
    isUwFlow: false,
    submissionDate: "",
    currentUser: "",
    visitTimestamp: "",
    uuid: "",
    sortKeyList: [],
    quoteData: {},
    address: [],
    quoteFactors: {},
    getQuoteClicked: false,
    uwQuesClassCodes: [],
    uwDynamicQuestion: [],
    getIndicationclicked: false,
    saveClicked: false,
    tableCarrierSelect: "",
    modifier_details: {},
    // displayLoader: false,
    pricingTableData: {},
    proposalCarrier: "",
    tableType: "",
    deductible: "",
    archivalFlow: false,
    isArchivalFlow: false,
    existingFlow: false,
    landToProposal: false,
    currentFormStage: 0,
    existingStatus: "",
    isPibitUploadPending: false,
    eligibleCarrierList: [],
  };

  updateSelectedCarrierMap = async (
    carrier,
    value,
    program,
    state,
    state_value,
    selectedStateList
  ) => {
    let { currentCarrierMap, perStateQuoteTableData } = this.state;
    let _currentCarrierMap = JSON.parse(JSON.stringify(currentCarrierMap));

    _currentCarrierMap[carrier] = value;

    if (state && program) {
      if (perStateQuoteTableData[state][program]) {
        perStateQuoteTableData[state].checked[program] = state_value;
      }
    }

    if (!state && program) {
      for (let _state in perStateQuoteTableData) {
        if (perStateQuoteTableData[_state][program]) {
          perStateQuoteTableData[_state].checked[program] = value;
        }
      }
    }

    this.setState({
      perStateQuoteTableData,
      currentCarrierMap: _currentCarrierMap,
    });
  };

  render() {
    let { displayLoader } = this.state;
    return (
      <LibertateContext.Provider
        value={{
          ...this.state,
          setContextData: (key, data) => {
            this.setState({ [key]: data });
          },

          setUserData: (data) => {
            this.setState({ userData: data });
          },
          setUserStatusData: (data) => {
            this.setState({ userStatusData: data });
          },
          setUwNetRates: (data) => {
            this.setState({ uwNetRates: data });
          },
          updateSelectedCarrierMap: this.updateSelectedCarrierMap,
          setPerStateQuoteTableData: (data) => {
            this.setState({ perStateQuoteTableData: data });
          },

          setPrograms: (data) => {
            this.setState({ programs: data });
          },
          setMasterWithoutFundRateMap: (data) => {
            this.setState({ masterWithoutFundRateMap: data });
          },
          setProgramStateType: (data) => {
            this.setState({ programStateType: data });
          },
          setPeoData: (data) => {
            this.setState({ peoData: data });
          },
          setExcludedClassCodeMap: (data) => {
            this.setState({ excludedClassCodeMap: data });
          },
          setCurrentCarrierMap: (data) => {
            this.setState({ currentCarrierMap: data });
          },
          setStateCarrierData: (data) => {
            this.setState({ stateCarrierData: data });
          },
          setUwFileList: (data) => {
            this.setState({ uwFileList: data });
          },
          setCarrierBasedData: (data) => {
            this.setState({ carrierBasedData: data });
          },
          setHideButtons: (data) => {
            this.setState({ hideButtons: data });
          },
          setFormStage: (data) => {
            this.setState({ formStage: data });
          },
          setCurrProspect: (data) => {
            this.setState({ currProspect: data });
          },
          setclassCodesObjectContext: (data) => {
            this.setState({ classCodeObjectContext: data });
          },
          startLoader: () => {
            this.setState({ displayLoader: true });
          },
          stopLoader: () => {
            this.setState({ displayLoader: false });
          },
          setIsUwFlow: (val) => {
            this.setState({ isUwFlow: val });
          },
          setSubmissionDate: (data) => {
            this.setState({ submissionDate: data });
          },
          setCurrentUser: (data) => {
            this.setState({ currentUser: data });
          },
          setUwQuesClassCodes: (data) => {
            this.setState({ uwQuesClassCodes: data });
          },
          setUwDynamicQuestions: (data) => {
            this.setState({ uwDynamicQuestion: data });
          },
          setPricingTableData: (data) => {
            this.setState({ pricingTableData: data });
          },
          setProposalCarrier: (data) => {
            this.setState({ proposalCarrier: data });
          },
          resetEntireState: () => {
            let isLoggedIn = sessionStorage.getItem("isLoggedIn");
            let selectedTab = sessionStorage.getItem("selectedTab");
            sessionStorage.clear();
            if (isLoggedIn) {
              sessionStorage.setItem("isLoggedIn", isLoggedIn);
            }
            if (selectedTab) {
              sessionStorage.setItem("selectedTab", selectedTab);
            }
            this.setState({
              perStateQuoteTableData: {},
              programs: [],
              masterWithoutFundRateMap: {},
              programStateType: {},
              peoData: {},
              excludedClassCodeMap: {},
              currentCarrierMap: {},
              stateCarrierData: {},
              uwNetRates: {},
              uwFileList: {
                third: {},
              },
              carrierBasedData: {},
              hideButtons: false,
              userStatusData: {},
              userData: {},
              formStage: "zero",
              currProspect: {},
              classCodeObjectContext: {},
              displayLoader: true,
              acordUwQues: [],
              isUwFlow: false,
              submissionDate: "",
              currentUser: "",
              visitTimestamp: "",
              uuid: "",
              sortKeyList: [],
              quoteData: {},
              address: [],
              quoteFactors: {},
              address: [],
              quoteFactors: {},
              getQuoteClicked: false,
              uwQuesClassCodes: [],
              uwDynamicQuestion: [],
              getIndicationclicked: false,
              saveClicked: false,
              tableCarrierSelect: "",
              modifier_details: {},
              pricingTableData: {},
              proposalCarrier: "",
              tableType: "",
              deductible: "",
              archivalFlow: false,
              isArchivalFlow: false,
              existingFlow: false,
              landToProposal: false,
              currentFormStage: 0,
              existingStatus: "",
              eligibleCarrierList: [],
            });
          },
          updateCurrentFormStage: (data) => {
            this.setState({ currentFormStage: data });
          },
          setEligibleCarrierList: (data) => {
            this.setState({ eligibleCarrierList: data });
          },
        }}
      >
        {this.props.children}
      </LibertateContext.Provider>
    );
  }
}

export const useLibertateContext = () => React.useContext(LibertateContext);
